import React from "react";
import { BackgroundImage, HeaderComponent } from "../../FifthComponents";
import img from "../../fifthAssets/Images/contact-img.jpg"
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import allPaths from "../../Config/paths"

const FootLab = (props) => {
    const history = useHistory()
    const { selectedLanguage } = props;
    return (
        <div>
            <BackgroundImage screenName={selectedLanguage?.txt_foot_lab_gait_analysis} classForBg='fifth-des-footLab-bg' {...props}/>
            <HeaderComponent title={selectedLanguage?.txt_foot_lab_gait_analysis} lineClass='bg-gray' titleClass='color-blue' />
            <div className="fifth-des-contact-div">
                <div className="fifth-des-pediatric-text-div fifth-des-footLab-text-div">
                    <p>
                        {selectedLanguage?.txt_foot_affects_gait}
                    </p>
                    <p>
                        {selectedLanguage?.txt_healthy_feet_gait}
                    </p>
                    <p>
                        {selectedLanguage?.txt_podiatry_physical_complaints}
                    </p>
                    <p>
                        {selectedLanguage?.txt_healthy_feet_athletes}
                    </p>
                    <p>
                        <b>{selectedLanguage?.txt_amsterdam_clinics}</b> {selectedLanguage?.txt_provides_a_foot_scan}
                    </p>
                    <p>
                        {selectedLanguage?.txt_gait_analysis_core_component}
                    </p>
                    <h2>
                        {selectedLanguage?.txt_candidates}
                    </h2>
                    <p>
                        – {selectedLanguage?.txt_people_who_have_complaints}
                    </p>
                    <ul>
                        <li>
                            {selectedLanguage?.txt_solving_complaints}
                        </li>
                        <li>
                            {selectedLanguage?.txt_improving_gait}
                        </li>
                        <li>
                            {selectedLanguage?.txt_improving_posture}
                        </li>
                        <li>
                            {selectedLanguage?.txt_solving_abnormal_position}
                        </li>
                    </ul>
                    <p>– 
                        {selectedLanguage?.txt_athletes_higher_performance}
                    </p>
                </div>
                <div className="fifth-des-contact-img-div">
                    <img onClick={() => history?.push(allPaths?.FIFHTAPPOINTMENT)} src={img} alt="" />
                </div>
            </div>
        </div>
    )
}
export default FootLab